import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.9 24.8 16 6l10.1 18.8zM17.8 4.3a2 2 0 0 0-3.6 0l-10.8 20a2 2 0 0 0 1.8 2.9h21.6a2 2 0 0 0 1.8-3zM16 11.6q-1.1 0-1.2 1.2v5.6a1.2 1.2 0 1 0 2.4 0v-5.6q0-1.1-1.2-1.2m1.3 10.8a1.3 1.3 0 0 0-2-1.2q-.7.4-.6 1.2a1.3 1.3 0 0 0 2 1.2q.7-.4.6-1.2" })
});
export default SvgWarningRegularIcon;
